import { Grid, Typography, useTheme } from "@mui/material";
import { GridSortItem, GridSortModel } from "@mui/x-data-grid";
import React from "react";

interface Props {
  title: string;
  fieldName: string;
  handleChangeSortModel: (model: GridSortModel) => void;
  sortModel: GridSortItem[];
}

const SortingCell = ({ title, fieldName, handleChangeSortModel, sortModel }: Props) => {
  const theme = useTheme();
  const currentSort = sortModel.find((item) => item.field === fieldName);
  const isActive = !!currentSort;
  const sortDirection = currentSort?.sort;

  const handleClick = () => {
    const newSort = !isActive ? "asc" : sortDirection === "asc" ? "desc" : "asc";
    handleChangeSortModel([
      {
        field: fieldName,
        sort: newSort,
      },
    ]);
  };

  return (
    <Grid
      style={{
        display: "flex",
        gap: "8px",
        cursor: "pointer",
        alignItems: "center",
        backgroundColor: isActive ? theme.palette.primary.main : "transparent",
        padding: isActive ? "8px 16px" : undefined,
        borderRadius: "10px",
      }}
      onClick={handleClick}
    >
      <Typography style={{ color: isActive ? "white" : theme.palette.text.primary }}>{title}</Typography>
      {isActive && (
        <Typography style={{ color: isActive ? "white" : theme.palette.text.primary }}>
          {sortDirection === "asc" ? "↑" : "↓"}
        </Typography>
      )}
    </Grid>
  );
};

export default SortingCell;
